module.exports = __webpack_public_path__ + "media/images/flags/64/United-Arab-Emirates-583706b45a6fa00c9c22b44907cf4ee5.png";